"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORTED_ISSUE_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var UserFragment_1 = require("./UserFragment");
exports.REPORTED_ISSUE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ReportedIssue on ReportedIssue {\n    id\n    objectId\n    issueType\n    message\n    created\n    reportedBy {\n      ...User\n    }\n  }\n  ", "\n"], ["\n  fragment ReportedIssue on ReportedIssue {\n    id\n    objectId\n    issueType\n    message\n    created\n    reportedBy {\n      ...User\n    }\n  }\n  ", "\n"])), UserFragment_1.USER_FRAGMENT);
var templateObject_1;
